import React, { useEffect, useLayoutEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import {
  searchUsersWithMessages,
  setDisconnectUsersWithMessages,
  setUsersWithMessages,
  setUsersWithMessagesEmpty,
} from "../../../../redux-toolkit/features/slices/chatSlice/chatSlice";
import SingleItem from "./SingleItem";
import { useGetSingleAdminDataQuery } from "../../../../redux-toolkit/services/AdminApi/AdminApi";
import { useSearchParams } from "react-router-dom";
import ChatService from "../../../../redux-toolkit/services/chatService/chatService";
import { useGetUserPermissionQuery } from "../../../../redux-toolkit/services/UserApi/UserApi";
import { BsFillPersonLinesFill } from "react-icons/bs";

const UserOnline = () => {
  const [searchParams] = useSearchParams();
  const path = searchParams.get("path");
  const dispatch = useDispatch();
  const { usersWithMessages, onlineUsers, typingInfo, adminTypingInfo } = useSelector((state) => state?.chat);

  // ========= Fetch admin data only once for typing =========
  const currentAdminEmail = adminTypingInfo?.[0]?.adminEmail;
  const { data: adminData } = useGetSingleAdminDataQuery(currentAdminEmail, {
    skip: !currentAdminEmail
  });

  const { AuthInfo } = useSelector((state) => state?.auth);

  const { data: UserPermissionData } = useGetUserPermissionQuery(AuthInfo?._id, {
    skip: !AuthInfo?._id,
  });

  const permissionIds = UserPermissionData?.data !== "all" ? new Set(
    (UserPermissionData?.data || []).map(id => id.toString())
  ) : new Set(
    ([]).map(id => id.toString())
  );

  const filteredUsers =
    permissionIds.size === 0
      ? usersWithMessages
      : usersWithMessages.filter(user =>
        permissionIds.has(user._id.toString())
      );


  useEffect(() => {
    dispatch(setUsersWithMessagesEmpty([]));
  }, [path]);

  useEffect(() => {
    if (onlineUsers?.length) {
      dispatch(setUsersWithMessages(onlineUsers));
    }
  }, [onlineUsers]);

  // ========= UI height set =========
  const [height, setHeight] = useState(0);
  useLayoutEffect(() => setHeight(window.innerHeight), []);


  const handleSearch = (e) => {
    dispatch(searchUsersWithMessages(e.target.value));
  };


  useEffect(() => {
    ChatService.listen("userListUpdate", (data) => {
      if (data) {
        dispatch(setDisconnectUsersWithMessages(data));
      }
    });

    return () => {
      ChatService.remove("userListUpdate");
    };
  }, []);

  return (
    <>

      <div className="live-chat-section">

        {/* Header */}
        <div className="live-chat-header">
          <BsFillPersonLinesFill className="live-chat-header-icon" />

          <span className="live-chat-title">
            Online users
          </span>

          {/* <span className="live-chat-count">
            (1)
          </span> */}
        </div>

        <div className="search-wrap">
          <div className="input-group">
            <input type="text" className="form-control"
              placeholder="Search user" onChange={handleSearch} />
            <span className="input-group-text"><CiSearch /></span>
          </div>
        </div>


        <>

          {usersWithMessages?.length ? (
            usersWithMessages.map((user) => (
              <SingleItem
                key={user._id}
                data={user}
                typingInfo={typingInfo}
                adminTypingInfo={adminTypingInfo}
                onlineUsers={onlineUsers}
                adminData={adminData?.data}
              />
            ))
          ) : (
            <p className="text-center" style={{ height: `${parseInt(height) - 100}px` }}>No users found</p>
          )}


        </>



      </div>
    </>
  );
};

export default UserOnline;
